<template>
  <v-card>
    <v-container>
      <v-card-title>
        <span class="pl-1 primary--text">{{ formEditTitle }}</span>
      </v-card-title>
      <v-card-text class="pb-0">
        <v-form
          v-model="isFormValid"
          ref="form"
          form="form"
          id="form"
          @submit.prevent="saveEdit()"
        >
          <v-row class="mb-4">
            <v-col cols="6" md="6" class="py-0">
              <v-text-field
                dense
                outlined
                v-model="nomConexion"
                :disabled="isDetalle"
                label="Nombre de conexión"
                :rules="
                  rules.required.concat(
                    [rules.requiredTrim(nomConexion)],
                    [rules.maxLength(nomConexion, 250)]
                  )
                "
                type="text"
                hide-details="true"
              ></v-text-field>
            </v-col>
            <v-col cols="6" md="6" class="py-0">
              <v-text-field
                dense
                outlined
                v-model="datoConexion"
                :disabled="isDetalle"
                :rules="
                  rules.required.concat([rules.requiredTrim(datoConexion)])
                "
                label="IP o url de conexión"
                type="text"
                hide-details="true"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="mb-4">
            <v-col cols="6" md="6" class="py-0">
              <v-text-field
                dense
                outlined
                v-model="puerto"
                label="Puerto"
                :disabled="isDetalle"
                :rules="rules.required.concat([rules.requiredTrim(puerto)])"
                type="text"
                hide-details="true"
              ></v-text-field>
            </v-col>
            <v-col cols="6" md="6" class="py-0">
              <v-text-field
                dense
                outlined
                v-model="dominio"
                label="Dominio"
                :disabled="isDetalle"
                :rules="rules.required.concat([rules.requiredTrim(puerto)])"
                type="text"
                hide-details="true"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="mb-4">
            <v-col cols="6" md="6" class="py-0">
              <v-text-field
                dense
                outlined
                v-model="usuario"
                :disabled="isDetalle"
                :rules="rules.required.concat([rules.requiredTrim(usuario)])"
                label="Usuario"
                type="text"
                hide-details="true"
              ></v-text-field>
            </v-col>
            <v-col cols="6" md="6" class="py-0">
              <v-text-field
                outlined
                dense
                onkeydown="return (event.keyCode !== 32)"
                label="Contraseña (*)"
                :append-icon="
                  !contrasenia
                    ? ''
                    : passwordTextType
                    ? 'mdi-eye'
                    : 'mdi-eye-off'
                "
                @click:append="() => (passwordTextType = !passwordTextType)"
                :type="passwordTextType ? 'password' : 'text'"
                :rules="
                  rules.required.concat(
                    [rules.maxLength(contrasenia, 100)],
                    [rules.requiredTrim(contrasenia)]
                  )
                "
                autocomplete="new-password"
                v-model.trim="contrasenia"
                :readonly="isDetalle"
                hide-details="true"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <!-- Tipo de texto -->
            <v-col cols="12" md="12" class="py-0">
              <v-textarea
                v-model="observaciones"
                label="Observaciones"
                dense
                :disabled="isDetalle"
                :rules="
                  rules.required.concat(
                    [rules.maxLength(observaciones, 250)],
                    [rules.requiredTrim(observaciones)]
                  )
                "
                auto-grow
                rows="4"
                outlined
                hide-details="true"
              ></v-textarea>
            </v-col>
            <v-col cols="12" md="12" class="py-0">
              <v-switch
                class="py-0"
                v-model="habilitado"
                label="Habilitado"
                dense
                outlined
                :disabled="isDetalle"
                hide-details="true"
              ></v-switch>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn outlined @click="closeModal(false)"> Cancelar </v-btn>
        <v-btn
          type="submit"
          :disabled="!isFormValid"
          :loading="loadingSaveBtn"
          form="form"
          color="primary"
          v-if="!isDetalle"
        >
          Guardar
        </v-btn>
      </v-card-actions>
    </v-container>
  </v-card>
</template>
<script>
import rules from "@/utils/helpers/rules";
import { mapActions } from "vuex";
export default {
  name: "EditConexionRdp",
  props: {
    registrosParams: {
      Type: Object,
      required: false,
      default: null,
    },
    idReg: {
      Type: Number,
    },
    isDetalle: {
      Type: Boolean,
      required: false,
      default: false,
    },
  },
  data: () => ({
    usuario: null,
    datoConexion: null,
    nomConexion: null,
    contrasenia: null,
    puerto: "",
    dominio: "",
    formEditTitle: "Nueva conexión vía RDP",
    rules: rules,
    passwordTextType: String,
    habilitado: true,
    isFormValid: false,
    usuarioSelected: null,
    observaciones: null,
    loadingSaveBtn: false,
  }),
  created() {
    if (this.registrosParams != null) {
      this.formEditTitle = "Editar conexión vía RDP";
      this.setConexionRdp();
    }
  },
  methods: {
    ...mapActions({
      saveConexion: "clientesData/saveConexion",
      setAlert: "user/setAlert",
    }),
    async setConexionRdp() {
      this.nomConexion = this.registrosParams.nombreConexion;
      this.datoConexion = this.registrosParams.datoIp;
      this.usuario = this.registrosParams.usuario;
      this.puerto = this.registrosParams.puerto;
      this.dominio = this.registrosParams.dominio;
      this.contrasenia = this.registrosParams.contrasenia;
      this.observaciones = this.registrosParams.observaciones;
      this.habilitado = this.registrosParams.habilitado;
    },
    async saveEdit() {
      this.loadingSaveBtn = true;
      const data = {
        id:
          this.registrosParams?.id != null
            ? parseInt(this.registrosParams.id)
            : null,
        clienteId: parseInt(this.idReg),
        nombreConexion: this.nomConexion,
        nombreIp: this.datoConexion,
        usuario: this.usuario,
        habilitado: this.habilitado,
        contrasenia: this.contrasenia,
        dominio: this.dominio,
        puerto: this.puerto,
        observaciones: this.observaciones ? this.observaciones : null,
      };
      try {
        const response = await this.saveConexion(data);
        if (response.status === 200) {
          this.loadingSaveBtn = false;
          this.closeModal(true);
          this.setAlert({ type: "success", message: "Guardado con éxito." });
        }
      } catch (error) {
        if (this.registrosParams) {
          this.loadingSaveBtn = false;
        } else {
          this.loadingSaveBtn = false;
          this.nomConexion = null;
          this.datoConexion = null;
          this.usuario = null;
          this.contrasenia = null;
          this.puerto;
          this.dominio;
          this.observaciones = null;
          this.habilitado = false;
        }
      }
    },
    closeModal(reload) {
      this.$emit("closeAndReload", reload);
    },
  },
};
</script>

<style scoped>
/* ::v-deep label {
  margin-bottom: 0;
}
::v-deep .theme--light.v-input--is-disabled input,
.theme--light.v-input--is-disabled textarea {
  color: rgb(56, 56, 56);
}
::v-deep .v-select__selection,
.v-select__selection--comma,
.v-select__selection--disabled input {
  color: black !important;
}

::v-deep .v-input__slot {
  cursor: context-menu !important;
} */

/* ::v-deep label {
  margin-bottom: 0;
}
::v-deep .theme--light.v-input--is-disabled textarea {
  color: rgb(56, 56, 56, 1);
} */
</style>
